import { render, staticRenderFns } from "./CardPagination.vue?vue&type=template&id=7663bf88&scoped=true"
import script from "./CardPagination.vue?vue&type=script&lang=js"
export * from "./CardPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7663bf88",
  null
  
)

export default component.exports